import React, { useState, useEffect, useRef } from 'react'

import { isLatLng } from "../../../helpers/isLatLng"

export default function Search({ updateSearchTerms, searchTerm, searchType }) {

  const SEARCH_RESTAURANTS = 'restaurant'
  const SEARCH_LOCATIONS = 'location'

  const  [ inputValue, setInputValue ] = useState('')
  const  [ typeInputValue, setTypeInputValue ] = useState(SEARCH_RESTAURANTS)

  const prevTypeRef = useRef()
  const prevType = prevTypeRef.current

  const onBtnClick = () => {

    updateSearchTerms(
      {
        'value': inputValue,
        'type': typeInputValue,
      },
      'add_terms',
    )

  }

  const resetTerm = () => {
    setInputValue("")
  }

  const handleInputChange = ( value ) => {
    setInputValue(value)
  }

  const handleKeyPress = (e) => {
    if (e.keyCode == 13) {
      onBtnClick()
    }
  }

  useEffect(() => {
    if ( inputValue !== searchTerm ) {
      setInputValue(searchTerm)
    }
  }, [searchTerm])

  useEffect(() => {
    if ( inputValue !== searchTerm ) {
      setInputValue(searchTerm)
    }
  }, [])

  useEffect(() => {
    if ( inputValue !== searchType ) {
      setTypeInputValue(searchType)
    }
  }, [searchType])

  useEffect(() => {
    if ( inputValue !== searchType ) {
      setTypeInputValue(searchType)
    }
  }, [])

  useEffect(() => {
    prevTypeRef.current = typeInputValue

    if (prevType !== typeInputValue) {
      onBtnClick()
    }
  })

  const isLocationSearchText = isLatLng(inputValue)

  return (
    <div className="c-searchTerms">
      <div className="c-searchTerms__inputWrapper">
        <input className="c-searchTerms__search form-control" value={isLocationSearchText ? "" : inputValue} onKeyDown={(e) => handleKeyPress(e)} onChange={(e) => handleInputChange(e.target.value)} />
        <div className="c-searchTerms__resetButton" onClick={resetTerm}><i className="icon ion-ios-close-circle"></i></div>
      </div>
      <div className="c-searchTerms__radios">
        <div className="h-radioButton h-radioButton--withText">
          <label className="h-radioButton__label">
            <input type="radio"
              name="test"
              value={SEARCH_RESTAURANTS}
              className="h-radioButton__input"
              id="search-restaurant-name"
              checked={typeInputValue === SEARCH_RESTAURANTS}
              onChange={(e) => setTypeInputValue(e.target.value)}
            />
            <div className="h-radioButton__icon" />
            <span>Restaurant or chef name</span>
          </label>
        </div>
        <div className="h-radioButton h-radioButton--withText">
          <label className="h-radioButton__label">
            <input type="radio"
              name="test"
              value={SEARCH_LOCATIONS}
              className="h-radioButton__input"
              id="search-location"
              checked={typeInputValue === SEARCH_LOCATIONS}
              onChange={(e) => setTypeInputValue(e.target.value)}
            />
            <div className="h-radioButton__icon" />
            <span>Location or postcode</span>
          </label>
        </div>
      </div>
      <button className="btn btn-primary btn-lg w-100" onClick={onBtnClick}>Search</button>
    </div>
  )
}
